import axios from '../../common/axios';
import type { Pathway } from '../../pages/pathways-page/types';

export async function fetchOwnedPathways(): Promise<Pathway[]> {
  const response = await axios.get('pathways/me', {
    params: { page: 0, pageSize: 100, type: 'owned', searchTerm: '' }
  });
  return response.data.items ?? [];
}
